<div class="widget">
  <div class="buttons" *ngFor="let vote of [vote$ | async]">
    <button (click)="toggleVote(vote == null ? 0 : vote.verdict)" class="votebutton" [class.selected]="vote?.verdict === 1">
      <mat-icon>thumb_up</mat-icon>
    </button>
  </div>
</div>
